module.exports = __webpack_public_path__ + "img/dequavian_transparent.90125303.gif";